import { ogApiGet, buildTokenHash } from  "//bark.co/cdn/shop/t/282/assets/ordergroove.js?v=10848403420202116351788363986";

async function checkPromotionalItemLimit() {
  const buyButtonsContainer = document.querySelector('.product-info__buy-buttons');
  if (!buyButtonsContainer) return;

  const maxPurchasableQty = buyButtonsContainer.getAttribute('data-max-purchasable-qty');

  // Only proceed if max_purchasable_qty metafield exists
  if (!maxPurchasableQty || maxPurchasableQty === '') {
    enableBuyButtons();
    hideQuantityLimitMessage();
    return;
  };

  const maxQty = parseInt(maxPurchasableQty, 10);
  const variantIdsStr = buyButtonsContainer.getAttribute('data-variant-ids');
  const variantIds = variantIdsStr ? variantIdsStr.split(',') : [];
  const nextOrderQty = await qtyUpcomingOrders(variantIds);
  const allTimePurchasedQty = await purchasedQty(variantIds);
  const totalQty = nextOrderQty + allTimePurchasedQty;

  // If limit is reached, disable buttons and show message
  if (totalQty >= maxQty) {
    disableBuyButtons();
    showQuantityLimitMessage();
  } else {
    updateQuantitySelectorMax(maxQty - totalQty);
    enableBuyButtons();
    hideQuantityLimitMessage();
  }
}

async function qtyUpcomingOrders(variantIds) {
  if (variantIds.length === 0) return false;

try {
    const tokenHash = buildTokenHash();
    const upcomingQuantities = await Promise.all(
      variantIds.map(async (variantId) => {
        const response = await ogApiGet(`/items/?product=${variantId}&omit_price_calculation=true&status=1`, tokenHash);
        const items = response.data.results || [];
        return itemQtyWithVariant(items, variantIds);
      })
    )
    const quantities = await upcomingQuantities;
    const totalUpcomingQty = quantities.reduce((sum, qty) => sum + qty, 0);

    return totalUpcomingQty;
  } catch (error) {
    console.error('Error fetching items in orders:', error);
    return 0;
  }
}

function itemQtyWithVariant(items, variantIds) {
  let totalQty = 0;
  items.forEach(item => {
    const itemVariantId = String(item.product || '');

    if (variantIds.includes(itemVariantId)) {
      totalQty += parseInt(item.quantity || 0, 10);
    }
  });

  return totalQty;
}

async function purchasedQty(variantIds) {
  if (variantIds.length === 0) return 0;

  try {
    const tokenHash = buildTokenHash();
    const purchasedQuantities = await Promise.all(
      variantIds.map(async (variantId) => {
        const response = await ogApiGet(`/items/?product=${variantId}&omit_price_calculation=true&status=5`, tokenHash);
        const items = response.data.results || [];
        return itemQtyWithVariant(items, variantIds);
      })
    )
    const quantities = await purchasedQuantities;
    const totalPurchasedQty = quantities.reduce((sum, qty) => sum + qty, 0);

    return totalPurchasedQty;
  } catch (error) {
    console.error('Error fetching items in orders:', error);
    return 0;
  }
}

function updateQuantitySelectorMax(allowedMax) {
  const quantityInput = document.querySelector('input[name="quantity"]');

  if (quantityInput) {
    quantityInput.max = allowedMax;
    quantityInput.value = 1;
  }
}

function disableBuyButtons() {
  const buyButtonsContainer = document.querySelector('.product-info__buy-buttons');
  if (!buyButtonsContainer) return;

  // Disable the add to upcoming order button within buy-buttons
  const button = buyButtonsContainer.querySelector('upcoming-order-add-button');
  if (button) {
    button.disabled = true;
    button.style.display = 'none';
  }

  // Hide the buy buttons container
  const buyButtonsWrapper = buyButtonsContainer.querySelector('.buy-buttons');
  if (buyButtonsWrapper) {
    buyButtonsWrapper.style.display = 'none';
  }
}

function enableBuyButtons() {
  const buyButtonsContainer = document.querySelector('.product-info__buy-buttons');
  if (!buyButtonsContainer) return;

  hideLoadingSpinner();
  buyButtonsContainer.style.display = '';

  // Enable the add to upcoming order button within buy-buttons
  const button = buyButtonsContainer.querySelector('upcoming-order-add-button');
  if (button) {
    if (button.textContent && !button.textContent.includes('Sold out')) {
      button.disabled = false;
    }
    button.style.display = '';
  }

  // Show the buy buttons container
  const buyButtonsWrapper = buyButtonsContainer.querySelector('.buy-buttons');
  if (buyButtonsWrapper) {
    buyButtonsWrapper.style.display = '';
  }
}

function showQuantityLimitMessage() {
  const messageElement = document.querySelector('.product-info__qty-limit-message');
  if (messageElement) {
    hideLoadingSpinner();
    messageElement.style.display = 'block';
  }
}

function hideQuantityLimitMessage() {
  const messageElement = document.querySelector('.product-info__qty-limit-message');
  if (messageElement) {
    messageElement.style.display = 'none';
  }
}

function hideLoadingSpinner() {
  const spinnerElement = document.querySelector('.product-info__qty-limit-loading');
  if (spinnerElement) {
    spinnerElement.style.display = 'none';
  }
}

// Listen for Ordergroove next order items fetched event
document.addEventListener('ognextorderitemsfetched', function(e) {
  // Store items in sessionStorage for easier access
  if (e.detail && e.detail.items) {
    sessionStorage.setItem('og-next-order-items', JSON.stringify(e.detail.items));
  }
  checkPromotionalItemLimit();
});

// Also check when variant changes
document.addEventListener('variant:change', function() {
  checkPromotionalItemLimit();
});

// Re-check after the custom variation-product picker (e.g. commitment length)
// swaps the section via AJAX. That flow dispatches `loadingStateChanged` once the
// new markup is in place, but it re-renders the buy buttons hidden behind the
// loading spinner and fires no `variant:change`, so we must re-run the limit
// check to reveal them again.
document.addEventListener('loadingStateChanged', function() {
  checkPromotionalItemLimit();
});

// Kick off on load. Neither event above is guaranteed to fire on a first paint —
// `ognextorderitemsfetched` only fires for a logged-in subscriber with an upcoming
// order — and any product carrying a `max_purchasable_qty` metafield renders its
// buy buttons hidden behind the spinner, so without this the ATC never appears.
if (document.readyState !== 'loading') {
  checkPromotionalItemLimit();
} else {
  document.addEventListener('DOMContentLoaded', checkPromotionalItemLimit);
}
